import React from 'react'
import './Home.css'
import { Link } from 'react-router-dom'
import { Button, Stack, Typography } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import { TrendingFlat } from '@mui/icons-material'
import BlockFullImage1Col from 'src/components/Common/BlockFullImage1Col'

export default function HomeJCK() {
  return (
    <BlockFullImage1Col
      image='https://meteor.stullercloud.com/das/149821532?wid=800'
      video='https://gemvision.com/Images/JCK_Animation_Home_Banner.mp4'
    >
      <Stack sx={{ alignItems: 'center', mt: { xs: 30, sm: 60 } }}>
        <Typography
          variant='h1'
          sx={{
            fontWeight: 800,
            fontSize: { xs: '2.5rem', sm: '3rem', md: '3.5rem', wordBreak: 'break-word' },
            textShadow: '0 0 20px #000'
          }}
        >
          <FormattedMessage id='home.jck2025.title' />
        </Typography>
        <Typography
          component='h2'
          sx={{
            my: 1,
            fontWeight: 500,
            fontSize: { xs: '1.2rem', sm: '1.3rem', md: '1.4rem' },
            textShadow: '0 0 10px #000',
            color: '#fff'
          }}
        >
          <FormattedMessage id='home.jck2025.description' />
        </Typography>
        <Typography
          sx={{
            mt: 0,
            mb: 3,
            color: '#fff',
            textShadow: '0 0 10px #000'
          }}
        >
          <FormattedMessage id='home.jck2025.excluding' />
        </Typography>
        <Button
          data-gtm-secondary-cta='Buy_Now'
          variant='contained'
          size='large'
          component={Link}
          to='/store'
          endIcon={<TrendingFlat />}
        >
          <FormattedMessage id='common.buyNow' />
        </Button>
      </Stack>
    </BlockFullImage1Col>
  )
}
